// extracted by mini-css-extract-plugin
export var deleteIcon = "_q8-5";
export var deleteOption = "_q8-3";
export var divider = "_q8-2";
export var downloadIcon = "_q8-4";
export var drawer = "_q8-0";
export var drawerFooter = "_q8-6";
export var drawerOpen = "_q8-1";
export var highlighted = "_q8-7";
export var lighterHighlight = "_q8-8";